// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AgreementList_wrapper__y_Tpg","agreement-wrapper":"AgreementList_agreement-wrapper__hIvC4","wrapper-pagination":"AgreementList_wrapper-pagination__KObco"};